import {isUndefined} from 'util';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie';
import {Injectable} from '@angular/core';
import {LocalStorage} from './local-storage';

@Injectable()
export class TokenCookieService {
    public AUTH_USER_INFO = 'AUTH_USER_INFO';
    public COOKIE_NAME = 'AUTHED';

    constructor(private router: Router, private _cookie: CookieService, private _local: LocalStorage) {
    }

    put_cookie(access_token, seconds?: number) {
        this._cookie.put(this.COOKIE_NAME, `${access_token}`, this.optionCookie(seconds));
    }


    remove_cookie() {
        this._cookie.remove(this.COOKIE_NAME);
        this._local.remove(this.AUTH_USER_INFO);
    }

    get_cookie() {
        return this._cookie.get(this.COOKIE_NAME);
    }

    optionCookie(seconds?: number) {
        if (isUndefined(seconds)) {
            seconds = 7200;
        }

        const dd = new Date();
        dd.setSeconds(dd.getSeconds() + seconds);

        // console.log(this.date_format(new Date(), 'yyyy-MM-dd hh:mm:ss'));
        // console.log(this.date_format(dd, 'yyyy-MM-dd hh:mm:ss'));
        const option = {
            path: '/',
            // domain: window.location.hash,
            expires: dd,
            secure: false,
        };
        return option;
    }
}
